import { LocationsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

export const locationsBaseKey = ["locations"] as const

export const locationsKey = (facilityId: string) =>
  [...locationsBaseKey, facilityId] as const

export const locationsQuery = makeQuery({
  serviceCall: (facilityId: string) =>
    LocationsService.listLocations({ facility_id: facilityId }),
  queryKey: locationsKey,
})

export const useCreateLocationMutation = makeAxiosMutation({
  serviceCall: LocationsService.create,
  invalidates: (params) => [locationsKey(params.facility_id)],
})

export const useUpdateLocationMutation = makeAxiosMutation({
  serviceCall: LocationsService.update,
  invalidates: (params) => [locationsKey(params.facility_id)],
})

export const useDeleteLocationMutation = makeAxiosMutation({
  serviceCall: LocationsService.delete,
  invalidates: (params) => [locationsKey(params.facility_id)],
})

export const archivedLocationsQuery = makeQuery({
  serviceCall: (facilityId: string) =>
    LocationsService.listLocations({ facility_id: facilityId, deleted: true }),
  queryKey: (facilityId) => [...locationsKey(facilityId), "archived"],
})

export const useRestoreLocationMutation = makeAxiosMutation({
  serviceCall: LocationsService.restore,
  invalidates: (params) => [locationsKey(params.facility_id)],
})
